var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap items-center justify-center w-full"},[_c('img',{staticClass:"w-48 h-48 mb-4",attrs:{"src":_vm.imageSrc,"alt":"No results","width":"192","height":"192"}}),_vm._v(" "),_c('h2',{staticClass:"w-full text-lg font-bold text-center"},[_vm._v("\n\t\t"+_vm._s(_vm.copy)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }